import { HumanMaleFemaleIcon } from './HumanMaleFemaleIcon';

/**
 * author: Google
 * id 0FC16450-7A7E-43C5-AED4-E27C4A6BFF99
 * name human-male-female
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/human-male-female.svg
 * tags
 * - People / Family 
 */
export const WcIcon = HumanMaleFemaleIcon;
export default WcIcon